import { OnInit, ElementRef, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/';
import { SpeechRecognitionService } from '../services/speech-recognition.service';
import { Observable } from 'rxjs';
var ConfirmationDialogComponent = /** @class */ (function () {
    function ConfirmationDialogComponent(bsModalRef, speechRecognitionService) {
        this.bsModalRef = bsModalRef;
        this.speechRecognitionService = speechRecognitionService;
        this.answer = "";
        this.inputText = "";
        this.enableSpeech = false;
        this.validateInput = "";
        this.invalid = false;
    }
    ConfirmationDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        if ('webkitSpeechRecognition' in window) {
            this.speechApi = true;
        }
        else {
            this.speechApi = false;
        }
        this.inputText = "";
        if (this.timeout) {
            this.timer = this.timeout;
            var timer = Observable.timer(0, 1000);
            this.sub = timer.subscribe(function (t) { return _this.incrementTimer(_this.timeout); });
        }
    };
    ConfirmationDialogComponent.prototype.incrementTimer = function (timeout) {
        this.timer--;
        if (this.timer == 0) {
            this.respond("Cancel");
            this.sub.unsubscribe();
        }
    };
    ConfirmationDialogComponent.prototype.respond = function (answer) {
        if (this.validateInput && (answer == "OK" || answer == "YES")) {
            if (this.text.nativeElement.value != this.validateInput) {
                this.invalid = true;
            }
            else {
                this.answer = answer;
                this.bsModalRef.hide();
            }
        }
        else {
            this.answer = answer;
            this.bsModalRef.hide();
        }
    };
    ConfirmationDialogComponent.prototype.onChange = function () {
        if (this.validateInput) {
            if (this.text.nativeElement.value == this.validateInput) {
                this.invalid = false;
            }
        }
    };
    ConfirmationDialogComponent.prototype.activateSpeech = function () {
        //this.showSearchButton = false;
        var _this = this;
        this.speechRecognitionService.record()
            .subscribe(
        //listener
        function (value) {
            _this.inputText = value;
            console.log(value);
        }, 
        //error
        function (err) {
            console.log(err);
            if (err.error == "no-speech") {
                console.log("--restarting service--");
                _this.activateSpeech();
            }
        }, 
        //completion
        function () {
            //this.showSearchButton = true;
            console.log("--complete--");
            //this.activateSpeech();
        });
    };
    ConfirmationDialogComponent.prototype.ngOnDestroy = function () {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    };
    return ConfirmationDialogComponent;
}());
export { ConfirmationDialogComponent };
